(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('motivo', {
                parent: 'public',
                url: '/motivo',
                redirectTo: 'motivo/list',
                data: {
                    authorities: []
                }
            })
            .state('motivo/list', {
                parent: 'motivo',
                url: '/listar',
                data: {
                    pageTitle: 'motivo.list.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/public/motivo/motivo.list.html',
                        controller: 'MotivoPublicController',
                        controllerAs: 'listCtrl'
                    }
                },
                resolve: {
                    /* @ngInject */
                    motivos: function (Motivo, LetrasService) {
                        return Motivo.findAllOrderByNombre().$promise.then(function (data) {
                            return LetrasService.getMapaLetras(data, 'nombre');
                        });
                    }
                }
            });
    }
})();
